import NextLink from "next/link";
// import { OutboundLink } from "react-ga";

const Anchor = (props) => {
  const { href } = props;
  const isInternalLink = href && (href.startsWith("/") || href.startsWith("#"));

  if (isInternalLink) {
    return (
      <NextLink href={href} passHref>
        <span textDecoration="underline" {...props} />
      </NextLink>
    );
  }

  return (
    <a
      // as={OutboundLink}
      to={href}
      textDecoration="underline"
      isExternal
      {...props}
    />
  );
};

export default Anchor;
